import React from 'react';
import Application from './components/app';
import './App.css';


import { Provider } from 'react-redux';
import store from './configStore'

const Root = () => (
  <Provider store={store}>
    <Application />
  </Provider>
)

export default Root;
